import { Modal, Typography, Button, Divider } from "antd";
import {
  RobotOutlined,
  ExportOutlined,
} from "@ant-design/icons";

const { Paragraph, Text } = Typography;

export const TelegramGuideModal = ({ isVisible, onCancel }) => {
  return (
    <Modal
    maskClosable={false}
      title={
        <div style={{ textAlign: "left", fontWeight: "bold" }}>
          <RobotOutlined style={{ marginRight: 8 }} />
          ขั้นตอนการสร้างห้องแจ้งเตือนใน Telegram 🤖
        </div>
      }
      open={isVisible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          ปิด
        </Button>,
      ]}
      width={700}
      centered
    >
      <div style={{ padding: "16px 24px", textTransform: "lowercase" }}>
        {/* Step 1 */}
        <p style={{ fontWeight: "bold", fontSize: "16px" }}>
          1. สร้างบอท (Bot)
        </p>
        <ul style={{ listStyleType: "disc", marginLeft: "-20px" }}>
          <li>เปิดแอป Telegram แล้วค้นหา **BotFather**</li>
          <li>
            เริ่มต้นการสนทนาโดยพิมพ์{" "}
            <code style={{ color: "#343a40" }}>/start</code>
          </li>
          <li>
            พิมพ์ <code style={{ color: "#343a40" }}>/newbot</code>{" "}
            และทำตามคำแนะนำเพื่อตั้งชื่อและ username ให้กับบอทของคุณ
          </li>
          <li>
            เมื่อเสร็จสิ้น คุณจะได้รับ **bot_token**
            ซึ่งเป็นรหัสสำคัญสำหรับเชื่อมต่อระบบของคุณกับบอท
            (เก็บรหัสนี้ไว้ให้ดี อย่าให้ใครเห็น)
          </li>
          <li>
            <Paragraph>
              <Text italic>ตัวอย่าง bot_token :</Text>{" "}
              <code style={{ color: "#343a40" }}>
                1234567890:ABC-DEF1234567890abcdef1234567890
              </code>
            </Paragraph>
          </li>
          <p className="mt-3" style={{ color: "#dc3545" }}>
            * Bot Token 1 ตัว สามารถสร้างได้หลายกลุ่ม โดยจะแยกทำงานตาม Chat ID
            ในขั้นตอนที่ 3
          </p>
        </ul>

        <Divider />

        {/* Step 2 */}
        <p style={{ fontWeight: "bold", fontSize: "16px" }}>
          2. สร้างกลุ่ม (Group)
        </p>
        <ul style={{ listStyleType: "disc", marginLeft: "-20px" }}>
          <li>สร้างกลุ่มใหม่ใน Telegram</li>
          <li>เชิญบอทที่คุณสร้างขึ้นในขั้นตอนที่ 1 เข้าไปในกลุ่ม</li>
          <li>
            <strong>สำคัญ:</strong> ตั้งค่าให้บอทเป็น <strong>Admin</strong>{" "}
            ของกลุ่ม เพื่อให้บอทมีสิทธิ์ส่งข้อความในกลุ่มได้
          </li>
        </ul>

        <Divider />

        {/* Step 3 */}
        <p style={{ fontWeight: "bold", fontSize: "16px" }}>
          3. หา chat_id ของกลุ่ม
        </p>
        <ul style={{ listStyleType: "disc", marginLeft: "-20px" }}>
          <li style={{textTransform:"capitalize"}}>เปิด  <a target="_blank" href="https://web.telegram.org/k/">Telegram บนเว็บเบราว์เซอร์ <ExportOutlined /></a></li>
          <li>ไปที่กลุ่มที่คุณสร้างขึ้น</li>
          <li>
            ดูที่ URL ของหน้าต่างนั้น คุณจะเห็น chat_id อยู่ในรูปแบบดังนี้:{" "}
            <br />
            <Paragraph>
              <code style={{ color: "#343a40" }}>
                https://web.telegram.org/k/#-1234567890
              </code>
            </Paragraph>
          </li>
          <li>
            <Paragraph>
              chat_id ของคุณคือต่อจาก{" "}
              <code style={{ color: "#343a40" }}>#</code> อย่าลืมเครื่องหมายลบ (
              <code style={{ color: "red" }}>-</code>) ด้านหน้าด้วย
            </Paragraph>
          </li>
          <li>
            <Paragraph>
              <Text italic>ตัวอย่าง chat_id :</Text> หาก URL คือ ...
              <code style={{ color: "#343a40" }}>#-1234567890</code> chat_id
              ของคุณคือ <code style={{ color: "red" }}>-1234567890</code>
            </Paragraph>
          </li>
        </ul>

        <p style={{ marginTop: "24px" }}>
          หลังจากทำตามขั้นตอนเหล่านี้ คุณก็จะได้ทั้ง{" "}
          <strong>bot_token <small><em>(Telegram Bot Token)</em></small></strong> และ{" "}
          <strong>chat_id</strong>{" "}
          เพื่อนำมากรอกเพิ่มห้องแชทเพื่อใช้แจ้งข้อมูลต่างๆได้แล้ว... 😁
        </p>
      </div>
    </Modal>
  );
};

export default TelegramGuideModal;
